import { MFA_TRUSTED_DEVICE_STORAGE_KEY } from './mfa-session'

export const clearAuthStoragePreservingMfaDevice = (): void => {
  const trustedDeviceToken: string | null = localStorage.getItem(MFA_TRUSTED_DEVICE_STORAGE_KEY)

  localStorage.clear()

  if (trustedDeviceToken) {
    localStorage.setItem(MFA_TRUSTED_DEVICE_STORAGE_KEY, trustedDeviceToken)
  }
}
